export const animateUp = () => {
  const acquisitionCritera = document.querySelectorAll(
    '.acquisition-critera .et_pb_row',
  );

  window.addEventListener('scroll', () => {
    if (window.scrollY > 600) {
      for (let i = 0; i < acquisitionCritera.length; i++) {
        acquisitionCritera[i].classList.add('animate-up');
      }
    }
  });
};
